import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TicketOfficeEventTab from './ticketOfficeEventTab';
import TicketOfficeEventItem from './ticketOfficeEventItem';
import { FrameCard, EmptyState, Icon } from '@weezevent/nacre';

export default function TicketOfficeEventList({ ticket_office, events, organization, selected, setSelected, syncTicketOffice }) {
    const history = useHistory();
    const { t } = useTranslation();
    const [order, setOrder] = React.useState('crst');
    const [selectAll, setSelectAll] = React.useState(false);

    const sortedEvents = React.useMemo(() => {
        if (!events || !events.length) {
            return [];
        }

        switch (order) {
            case 'alpha':
                events.sort((a, b) => a.name?.localeCompare(b?.name));
                break;
            case '-alpha':
                events.sort((b, a) => a.name?.localeCompare(b?.name));
                break;
            case 'crst':
                events.sort((a, b) => a.date?.localeCompare(b?.date));
                break;
            case '-crst':
                events.sort((b, a) => a.date?.localeCompare(b?.date));
                break;
            case 'id':
                events.sort((a, b) => a.id - b?.id);
                break;
            case '-id':
                events.sort((b, a) => a.id - b?.id);
                break;
            default:
                break;
        }

        return events;
    }, [events, order]);

    React.useEffect(() => {
        if (selectAll) {
            setSelected(sortedEvents);
        }
    }, [selectAll, sortedEvents]);

    React.useEffect(() => {
        // prevent filters that returns an empty list to select all events
        if (selected.length && selected.length === sortedEvents.length) {
            setSelectAll(true);
        }
    }, [selected, sortedEvents]);

    if (!events?.length) {
        return (
            <FrameCard>
                <EmptyState
                    icon={<Icon name="list" />}
                    title={t('ticket.ticket_offices.events_empty.title')}
                    subtitle={t('ticket.ticket_offices.events_empty.subtitle')}
                    labelButton={t('context_menu.cta_label_orga')}
                    onClick={() => history.push(`/ticket/O${organization.id}/events/new`)}
                />
            </FrameCard>
        );
    }

    return (
        <TicketOfficeEventTab order={order} setOrder={setOrder} selectAll={selectAll} setSelectAll={setSelectAll} setSelected={setSelected}>
            {sortedEvents &&
                sortedEvents.map((event, index) => (
                    <TicketOfficeEventItem
                        key={index}
                        ticket_office={ticket_office}
                        ticket_office_event={event}
                        organization={organization}
                        setSelectAll={setSelectAll}
                        selected={selected}
                        setSelected={setSelected}
                        syncTicketOffice={syncTicketOffice}
                    />
                ))}
        </TicketOfficeEventTab>
    );
}
